// import React, { Component } from 'react';

// class YouTubeShortEmbed extends Component {
//   render() {
//     const { videoId, isActive } = this.props;

//     // Change the key based on active state to force iframe to reload
//     const key = `${videoId}-${isActive ? 'playing' : 'paused'}`;
//     const autoplayParams = isActive ? 'autoplay=1&mute=1' : 'autoplay=0&mute=1';
//     const src = `https://www.youtube.com/embed/${videoId}?&modestbranding=1&rel=0&playsinline=1&controls=0&showinfo=0`;

//     return (
//       <div style={{ width: '200px', height: '254px' }}>
//         <iframe
//           key={key} 
//           width="200"
//           height="320"
//           src={src}
//           frameBorder="0"
//           allow="autoplay; encrypted-media"
//           allowFullScreen
//           title={`YouTube Short ${videoId}`}
//         ></iframe>
//       </div>
//     );
//   }
// }

// export default YouTubeShortEmbed;

import React, { Component } from 'react';
import YouTube from 'react-youtube';

class YouTubeShortEmbed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playerReady: false
    };
    this.playerRef = null;
  }

  componentDidMount() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isActive !== prevProps.isActive) {
      this.handlePlayback();
    }
    if (this.props.isVisible !== prevProps.isVisible) {
      this.handlePlayback();
    }
  }

  componentWillUnmount() { 
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    if (this.playerRef) {
      this.safePlayerCall('pauseVideo');
      this.safePlayerCall('mute');
    }
    this.playerRef = null;
  }
 
  handleVisibilityChange = () => {
    if (document.hidden && this.playerRef && this.props.isActive) { 
      this.safePlayerCall('pauseVideo');
    } else if (!document.hidden && this.playerRef && this.props.isActive) { 
      this.safePlayerCall('playVideo');
    }
  };

  safePlayerCall = (method, ...args) => {
    if (!this.playerRef || !this.state.playerReady) return false;
    
    try {
      if (typeof this.playerRef[method] === 'function') {
        this.playerRef[method](...args);
        return true;
      }
    } catch (error) {
      console.error(`YouTube API error (${method}):`, error);
    }
    return false;
  };

  handlePlayback = () => {
    const { isActive } = this.props;
    
    if (!this.playerRef || !this.state.playerReady) {
      return;
    }

    if (isActive) {
      // When becoming active, ensure all other videos are paused first
      this.safePlayerCall('mute');
      this.safePlayerCall('playVideo');
      
      // Unmute after a short delay to prevent audio overlap
      setTimeout(() => {
        if (this.props.isActive) { 
          this.safePlayerCall('unMute');
        }
      }, 300);
    } else {
      // When becoming inactive, ensure video is paused and muted
      this.safePlayerCall('pauseVideo');
      this.safePlayerCall('mute');
    }
  };

  onReady = (event) => {
    this.playerRef = event.target;
    
    if (this.playerRef && typeof this.playerRef.playVideo === 'function') {
      this.setState({ playerReady: true }, () => {
        // Initialize video state based on active status
        if (this.props.isActive) {
          this.handlePlayback();
        } else {
          this.safePlayerCall('pauseVideo');
          this.safePlayerCall('mute');
        }
      });
    }
  };

  onStateChange = (event) => {
    const { isActive } = this.props;
    const state = event.data;
    
    // Handle video end
    if (state === 0 && isActive) {
      this.safePlayerCall('seekTo', 0);
      this.safePlayerCall('playVideo');
    }
    
    // Ensure video is paused if it's not the active slide
    if ((state === 1 || state === 3) && !isActive) {
      this.safePlayerCall('pauseVideo');
      this.safePlayerCall('mute');
    }
  };

  render() {
    const { videoId } = this.props;
    
    const opts = {
      // width: '100%',
      height: '320',
      playerVars: {
        autoplay: 0,
        mute: 1,
        controls: 0,
        modestbranding: 1,
        rel: 0,
        playsinline: 1,
        enablejsapi: 1,
        origin: window.location.origin,
        loop: 0,
      },
    };

    return (
      <div className="youtube-short-wrapper" style={{ width: '-webkit-fill-available' }} data-active={this.props.isActive}>
        <YouTube
          videoId={videoId}
          opts={opts}
          onReady={this.onReady}
          onStateChange={this.onStateChange}
          onError={(e) => console.error(`YouTube player error (${videoId}):`, e)}
          className="youtube-short-player"
        />
      </div>
    );
  }
}

export default YouTubeShortEmbed;